module.exports = __webpack_public_path__ + "img/newLogo.d8c20a57.png";